/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlusOutlined } from '@ant-design/icons'
import {
  requestCheckEmailInSystem,
  requestCheckEmailInUehApi,
} from 'app/api/newTumRegister'
import {
  initValuesFormCreateTum,
  IPayloadCreateTradeUnionMember,
  ITradeUnionMember
} from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { Loading } from 'app/components/common/Loading'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { notificationController } from 'app/controllers/notification-controller'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { isValidDateDDMMYYYY } from 'app/hook'
import { useCreateTum } from 'app/react-query/hook/tradeUnionMember'
import dayjs from 'dayjs'
import { isEmpty, isEqual } from 'lodash'
import { moment, ResponseType } from 'parkway-web-common'
import { useEffect, useRef, useState } from 'react'
import { PositionEnum } from '../../type'
import { FormTumCommon, IFormCreateTradeUnionMember } from '../hook'


export const CreateTumModal = () => {
  const { user } = useVerifyPermission()
  const modalRef = useRef<IRefModal>({})
  const confirmSyncRef = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<IPayloadCreateTradeUnionMember>()
  const [email, setEmail] = useState('')
  const { mutateAsync, isLoading } = useCreateTum()
  const [loading, setLoading] = useState(false)
  const [isSync, setIsSync] = useState(false)

  const handleOpen = () => {
    modalRef.current?.open?.()
  }

  const handleSubmit = async (values: IFormCreateTradeUnionMember) => {
    if (!user?.member?.unit?.id) {
      notificationController.error({
        message: 'Bạn phải là đoàn viên và là quản lý của đơn vị này',
      })
      return
    }
    const res = await mutateAsync({
      ...values,
      chucVucongdoan: (values?.chucVucongdoan as unknown as string[]).join(','),
      ngaySinh: values?.ngaySinh?.format('DD/MM/YYYY'),
      ngayVaoUEH: values?.ngayVaoUEH?.format('DD/MM/YYYY'),
      ngayVaoCongDoan: values?.ngayVaoCongDoan?.format('DD/MM/YYYY'),
      ngayVaoDang: values?.ngayVaoDang?.format('DD/MM/YYYY'),
      isSync,
      unitId: user?.member?.unit?.id,
    })

    if (res) {
      modalRef.current?.hide?.()
      form?.resetFields()
      notificationController.success({
        message: 'Tạo mới đoàn viên thành công',
      })
    }
  }

  const handleValidateEmail = async () => {
    try {
      if (!isEmpty(email)) {
        const res: ResponseType<ITradeUnionMember> =
          await requestCheckEmailInSystem({ email })

        if (res?.data) {
          form.setFields([
            {
              name: 'email',
              errors: ['Email đã tồn tại'],
            },
          ])
        } else {
          const res: ResponseType<ITradeUnionMember> =
            await requestCheckEmailInUehApi({ email })
          if (res?.data) {
            if (isSync && isEqual(res?.data?.email, email)) return

            confirmSyncRef?.current?.open?.()
          }
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  const syncData = async () => {
    try {
      const res: ResponseType<ITradeUnionMember> =
        await requestCheckEmailInUehApi({ email })
      if (res?.data) {
        form.setFieldsValue({
          fullName: res?.data?.fullName,
          dienThoaiDiDong: res?.data?.dienThoaiDiDong,
          gioiTinh: res?.data?.gioiTinh,
          nguyenQuan: res?.data?.nguyenQuan,
          cmnd: res?.data?.cmnd,
          tenDonVi: res?.data?.tenDonVi,
          tinhTrangLamViec: res?.data?.tinhTrangLamViec,
          danToc: res?.data?.danToc,
          tonGiao: res?.data?.tonGiao ?? 'Không',
          noiOHienNay: res?.data?.noiOHienNay,
          hocHam: res?.data?.hocHam,
          hocVi: res?.data?.hocVi,
          soTheDoanVien: res?.data?.soTheDoanVien,
          chucVucongdoan: [res?.data?.chucVucongdoan ?? PositionEnum.DoanVien] as any,
          email: res?.data?.email,
          mql: res?.data?.mql,
          ngaySinh: (!isEmpty(res?.data?.ngaySinh) && isValidDateDDMMYYYY(res?.data?.ngaySinh)
            ? dayjs(moment(res?.data?.ngaySinh, 'DD/MM/YYYY').toDate())
            : undefined) as any,
          ngayVaoUEH: !isEmpty(res?.data?.ngayVaoUEH) && isValidDateDDMMYYYY(res?.data?.ngayVaoUEH)
            ? dayjs(moment(res?.data?.ngayVaoUEH, 'DD/MM/YYYY').toDate())
            : (undefined as any),
          ngayVaoCongDoan: !isEmpty(res?.data?.ngayVaoCongDoan) && isValidDateDDMMYYYY(res?.data?.ngayVaoCongDoan)
            ? dayjs(moment(res?.data?.ngayVaoCongDoan, 'DD/MM/YYYY').toDate())
            : (undefined as any),
          ngayVaoDang: !isEmpty(res?.data?.ngayVaoDang) && isValidDateDDMMYYYY(res?.data?.ngayVaoDang)
            ? dayjs(moment(res?.data?.ngayVaoDang, 'DD/MM/YYYY').toDate())
            : (undefined as any),
        })
        setIsSync(true)
        confirmSyncRef?.current?.hide?.()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const timer = setTimeout(async () => {
      handleValidateEmail()
    }, 500)
    return () => clearTimeout(timer)
  }, [email])

  const reset = () => {
    form?.resetFields()
    setEmail('')
  }

  return (
    <BaseModalComponent
      titleModal="Tạo mới đoàn viên"
      handleSubmit={form?.submit}
      buttonOpenModal={
        <BaseButton
          icon={<PlusOutlined rev={undefined} />}
          onClick={handleOpen}
        >
          {'Tạo mới đoàn viên'}
        </BaseButton>
      }
      isLoadingConfirm={isLoading}
      ref={modalRef}
      widthModal={900}
      renderContent={
        <BaseForm
          form={form}
          onFinish={handleSubmit}
          initialValues={initValuesFormCreateTum}
        >
          <FormTumCommon setEmail={setEmail} reset={reset} />
          {loading ? <Loading /> : null}

          <BaseModalComponent
            titleModal="Xác nhận lấy thông tin tồn tại từ UEH"
            handleSubmit={syncData}
            buttonOpenModal={<div />}
            ref={confirmSyncRef}
            renderContent={
              <BaseSpace>
                <BaseRow align={'middle'} justify={'center'}>
                  <BaseText fontWeight="medium" opacity="0.9">
                    {
                      'Đoàn viên này sẽ không thể khôi phục được và tài khoản đính kèm sẽ bị hạn chế chức năng khi không còn là đoàn viên!!'
                    }
                  </BaseText>
                </BaseRow>
              </BaseSpace>
            }
          />
        </BaseForm>
      }
    />
  )
}
